import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: "family-profile/:familyId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "family-profile" */ "./components"),
          import(
            /* webpackChunkName: "family-profile" */ "./modules/FamilyProfileModule"
          ),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          injectReducer(store, {
            key: "familyProfile",
            reducer,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
